import React from "react";
import { DailyReportMappingEnum } from "../../enum/normalization-mapping.enum.ts";
import DailyReportDataTable, {
  CustomColumn,
} from "../DailyReportDataTable/DailyReportDataTable.tsx";
import moment from "moment";

interface DailyReportDataGridProps {
  policies: any[];
  isLoading: boolean;
  formState?: {
    fromDate: string;
    toDate: string;
    company: string;
    policyType: string;
    agent: string;
    paymentPlaces: string[];
    selectedOffices: string[];
  };
  summary?: string | null;
  labelMaps?: {
    agents: { [key: string]: string };
    companies: { [key: string]: string };
    offices: { [key: string]: string };
    policyTypes: { [key: string]: string };
    paymentPlaces: { [key: string]: string };
  };
}

const DailyReportDataGrid: React.FC<DailyReportDataGridProps> = ({
  policies,
  isLoading,
  formState,
  summary,
  labelMaps,
}) => {
  const columns: CustomColumn[] = [
    {
      name: DailyReportMappingEnum.PolNum,
      header: "№",
      minWidth: 140,
      type: "string",
    },
    {
      name: DailyReportMappingEnum.InsType,
      header: "Вид",
      minWidth: 80,
      type: "string",
    },
    {
      name: DailyReportMappingEnum.InsComp,
      header: "ЗК",
      minWidth: 80,
      type: "string",
    },
    {
      name: DailyReportMappingEnum.Total_Sum,
      header: "Общо",
      minWidth: 75,
      type: "number",
    },
    {
      name: DailyReportMappingEnum.StickerSum,
      header: "Стикер (€)",
      minWidth: 60,
      maxWidth: 80,
      type: "number",
    },
    {
      name: DailyReportMappingEnum.InsPrem,
      header: "Премия",
      minWidth: 80,
      type: "number",
    },
    {
      name: DailyReportMappingEnum.CommOff,
      header: "Офис (%)",
      minWidth: 50,
      maxWidth: 60,
      type: "number",
    },
    {
      name: DailyReportMappingEnum.SumCommOff,
      header: "Офис (€)",
      minWidth: 60,
      type: "number",
    },
    {
      name: DailyReportMappingEnum.PayPlace,
      header: "Място",
      minWidth: 80,
      type: "string",
    },
    {
      name: DailyReportMappingEnum.Agent,
      header: "Агент/Офис",
      minWidth: 100,
      type: "string",
    },
    {
      name: DailyReportMappingEnum.SumCommAgent,
      header: "Агент (€)",
      minWidth: 50,
      maxWidth: 60,
      type: "number",
    },
    {
      name: DailyReportMappingEnum.CommAgent,
      header: "Агент (%)",
      minWidth: 50,
      maxWidth: 60,
      type: "number",
    },
    {
      name: DailyReportMappingEnum.AgentPay,
      header: "Платено",
      minWidth: 75,
      type: "string",
    },
    {
      name: DailyReportMappingEnum.TypeContr,
      header: "Тип договор",
      minWidth: 100,
      type: "string",
    },
    {
      name: DailyReportMappingEnum.GFSum,
      header: "ГФ",
      minWidth: 40,
      type: "number",
    },
    {
      name: DailyReportMappingEnum["2PercSum"],
      header: "2%",
      minWidth: 55,
      type: "number",
    },
    {
      name: DailyReportMappingEnum.Sticker,
      header: "№ Стикер",
      minWidth: 85,
      type: "string",
    },
    {
      name: DailyReportMappingEnum.SZK,
      header: "СЗК",
      minWidth: 65,
      type: "string",
    },
  ];

  const processedReportMetadata = [
    { label: "От дата", value: formState?.fromDate ?? "" },
    { label: "До дата", value: formState?.toDate ?? "" },
    {
      label: "Агент",
      value:
        labelMaps?.agents[formState?.agent || ""] ?? formState?.agent ?? "",
    },
    {
      label: "ЗК",
      value:
        labelMaps?.companies[formState?.company || ""] ??
        formState?.company ??
        "",
    },
    {
      label: "Вид Полица",
      value:
        labelMaps?.policyTypes[formState?.policyType || ""] ??
        formState?.policyType ??
        "",
    },
    {
      label: "Офис",
      value: (formState?.selectedOffices ?? [])
        .map((id) => labelMaps?.offices[id] ?? id)
        .join("; "),
    },
    {
      label: "Място на плащане",
      value: (formState?.paymentPlaces ?? [])
        .map((id) => labelMaps?.paymentPlaces[id] ?? id)
        .join("; "),
    },
  ];

  return (
    <DailyReportDataTable
      columns={columns}
      dataSource={policies}
      isLoading={isLoading}
      gridTitle="Дневен отчет"
      idProperty={DailyReportMappingEnum.PolNum}
      csvFilename={`Дневно приключване ${moment().format("DD/MM/YYYY")}`}
      icon="fa-kit fa-regular-file-circle-question"
      editable={false}
      printReportMetadata={processedReportMetadata}
      printReportSummary={summary}
    />
  );
};

export default DailyReportDataGrid;
